import { Link, type LinkProps } from "@tanstack/react-router";
import { ArrowUpRight } from "lucide-react";

export type GuideLink = { to: LinkProps["to"]; label: string; text: string };

/**
 * Kompakte Verweisliste auf passende Ratgeber- und Blogbeitraege.
 * Staerkt die interne Verlinkung von den Leistungsseiten aus.
 */
export function GuideLinks({
  title = "Passend zum Thema",
  links,
}: {
  title?: string;
  links: GuideLink[];
}) {
  return (
    <section className="border-t border-border/60 py-14">
      <div className="mx-auto max-w-6xl px-5">
        <h2 className="text-xl font-semibold md:text-2xl">{title}</h2>
        <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {links.map((l) => (
            <li key={l.label}>
              <Link
                to={l.to}
                className="group flex h-full flex-col rounded-xl border border-border/60 bg-card/40 p-5 transition-colors hover:border-primary/50"
              >
                <span className="flex items-start justify-between gap-3 font-medium">
                  {l.label}
                  <ArrowUpRight className="mt-0.5 size-4 shrink-0 text-muted-foreground transition-colors group-hover:text-primary" />
                </span>
                <span className="mt-2 text-sm text-muted-foreground">{l.text}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
